module.exports = __webpack_public_path__ + "sort_desc.png?1fc418e33fd5a687290258b23fac4e98";


//////////////////
// WEBPACK FOOTER
// ./node_modules/datatables.net-dt/images/sort_desc.png
// module id = 216
// module chunks = 0